module.exports = __webpack_public_path__ + "img/play-icon.aa20abd1.svg";